'use client';

import { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export function AOSInit() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    // Initialize AOS only on the client-side
    AOS.init({
      duration: 1000,
      offset: 0,
      once: true,
    });
    setIsMounted(true); // Set component as mounted
  }, []);

  // Do not render AOS classes until mounted
  if (!isMounted) return null;

  return null;
}
